import { useCallback, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ProductTypesTableContext } from '../contexts';

export const useProductTypesActionBar = () => {
  const { selection, selectAll, fetch, reset, resetSelection } = useContext(ProductTypesTableContext);

  const location = useLocation();
  const history = useHistory();

  const create = useCallback(() => {
    history.push('/@next/product-types/create', { background: location });
  }, [history, location]);

  return { selection, resetSelection, create, selectAll, reset, fetch };
};
